import { withInstall } from "../utils/index.mjs";
import _Switch from "./Switch.mjs";
const Switch = withInstall(_Switch);
var stdin_default = Switch;
import { switchProps } from "./Switch.mjs";
export {
  Switch,
  stdin_default as default,
  switchProps
};
